//  Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ISoftwareVersion, ISubscription } from '../../../../types/subscription';
import { get_uuid_filename } from '../../../../shared/subscription.methods';
import { ActionService } from '../../../../services/action-service';
import multiDownload from 'multi-download';
import { NotificationService } from '../../../../services/notification-service';
import { TranslateService } from '@ngx-translate/core';
import { WindowService } from '../../../../services/window.service';

@Component({
    selector: 'app-download-cigent',
    templateUrl: './download-cigent.component.html',
    styleUrls: ['./download-cigent.component.scss'],
    standalone: false
})
export class DownloadCigentComponent implements OnChanges {
  @Input() subscription: ISubscription;
  @Input() softwareVersion: ISoftwareVersion;
  @Input() email: string;
  @Input() style: {} = {};
  installerName: string;
  isDownloadDisabled = true;
  loginUrl = '';
  inIFrame = false;

  constructor(private actionService: ActionService,
              private notification: NotificationService,
              private translate: TranslateService,
              private windowService: WindowService) {

    const hostName = this.windowService.getOrigin();
    const url = new URL('login', hostName);
    this.loginUrl = url.href;
    this.inIFrame = this.windowService.inIframe();
  }

  onDownloadClick() {
    if (this.softwareVersion.path && this.installerName) {
      multiDownload([this.softwareVersion.path], {
        rename: () => this.installerName
      });
      this.softwareDownloadNotification();
    } else {
      this.notification.showError(this.translate.instant('ERROR_OCCURRED_UNKNOWN'));
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.subscription && this.softwareVersion) {
      const subscriptionFilename = get_uuid_filename(this.softwareVersion, this.softwareVersion.system, this.subscription.uuid);
      this.installerName = subscriptionFilename.trim().split('/').pop();
      this.isDownloadDisabled = false;
    } else {
      this.isDownloadDisabled = true;
    }
  }

  softwareDownloadNotification() {
    const email = this.email ? this.email : null;
    this.actionService.postDownload(this.softwareVersion.path, 'download', email, this.subscription?.uuid);
  }

}
